import { required, email,requiredIf,maxValue,or,helpers,minLength,and } from 'vuelidate/lib/validators'
import { fileSize,date,time,dateAfter } from '@/ic-common/helpers/validation'
import { isCarriage, isTrain,minTrainCarriages, dateAfterDeparture } from './helpers'
export default {
  form: {
    email: {
      required,
      email
    },
    phone: {
      required
    },
    name: {
      required
    },
    agreement: {
      required
    },
    agreement_taryfa:{
      required
    },
    trainType: {
      required
    },
    peopleCount:{
      required, 
      maxValue:or(maxValue(80),isTrain)
    },
    carriages:{
      requiredIf: requiredIf(isCarriage),
      $each: {
        type: {requiredIf: requiredIf(isCarriage)},
      }
    },
    train: {
       type: {
          requiredIf: requiredIf(isTrain),
          minTrainCarriages,
       },
     },
    connection: {
      departureStation: { required },
      arrivalStation: { required },
      departureDate: { required, date },
      //departureTime: { required,time },      
      selected:  requiredIf(isCarriage) ,      
    },
    connection2: {
      departureDate: {
        date,
        dateAfter: dateAfterDeparture
      }
    },
    files: {
      
      $each: {
        contact_fileSize: fileSize({ min: 0, max: 5000 })
      }
    }
  }
}
